import {trim} from "lodash";

export default class PaymentTypeModel {
    constructor(json) {
        json = json || {};
        this.type = json.type || 'existing';
        this.token = json.token || null;
        this.brand = json.brand || '';
        this.exp = json.exp || {
            year: null,
            month: null
        };
        this.last4 = json.last4 || '';
        this.name = json.name || '';

    }

    wordsToUnderscore(key) {
        return trim(key).split(' ').join('_').toLowerCase();
    }

    get icon() {
        return '/img/payment_methods/' + trim(this.wordsToUnderscore(this.brand)) + '.png';
    }
}